module.exports = __webpack_public_path__ + "static/media/16.321fd6d4.jpg";